import styled from 'styled-components';
import { getColor } from '../colors/colors';

export const Card = styled.div`
    border: 1px solid ${getColor('gray', '300')};
    border-radius: 12px;
    padding: 1rem;
    overflow: auto;
`;
